export const FETCH_AREAS = "areas/FETCH_AREAS";
export const FETCH_AREAS_SUCCESS = "areas/FETCH_AREAS_SUCCESS";
export const FETCH_AREAS_FAIL = "areas/FETCH_AREAS_FAIL";
export const POSTAL_CODE_SEARCH_SG = "areas/POSTAL_CODE_SEARCH_SG";
export const SET_AREA = "areas/SET_AREA";
